import { Box, FlexLayout, Icon, Modal } from '@deity-io/portal-ui';
import { CACHE_FIRST, ENTITY_PATH, ENTITY_PATH_ID, LOCALE_DATE_OPTIONS } from 'contracts/constants';
import type { Dispatch, FC, SetStateAction } from 'react';
import { useLocation } from 'react-router-dom';
import {
  GetAllPackageVersionsDocument,
  useDeployPackageVersionMutation,
  useGetPackageQuery,
  useGetPackageVersionQuery
} from 'services/graphql/generated/hooks';
import { getParams } from 'utils';

type ModalProps = {
  packageId?: string;
  versionUuid?: string;
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
};
export const DeployPackageVersionModal: FC<ModalProps> = ({ packageId, versionUuid, isOpen, setIsOpen }) => {
  const { pathname } = useLocation();
  const params = getParams(pathname, [ENTITY_PATH_ID, ENTITY_PATH]);

  const { data: packageVersion } = useGetPackageVersionQuery({
    variables: {
      uuid: versionUuid || params?.versionUuid
    },
    skip: !(versionUuid || params?.versionUuid),
    ...CACHE_FIRST
  });

  const { data: packageData } = useGetPackageQuery({
    variables: {
      uuid: packageId || params?.packageId
    },
    skip: !(packageId || params?.packageId)
  });

  const [deploy] = useDeployPackageVersionMutation({
    variables: { uuid: versionUuid || params?.versionUuid },
    refetchQueries: [
      // {
      //   query: GetPackageVersionDocument,
      //   variables: {
      //     versionUuid: versionUuid || params?.versionUuid
      //   }
      // },
      {
        query: GetAllPackageVersionsDocument,
        variables: {
          packageUuid: packageId || params?.packageId,
          limit: 20,
          offset: 0
        }
      }
    ]
  });

  return packageVersion?.getPackageVersion?.version ? (
    <Modal
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
      confirmText="Confirm & Deploy version"
      closeIcon={<Icon icon="close" />}
      onConfirm={async () => {
        await deploy();
        setIsOpen(false);
      }}
      title="Deploy package"
    >
      <Box my={2}>
        <Box my={2} px={3} py={2} bgcolor="#fffceb" borderLeft="5px solid #ecc155">
          <p>
            You are about to deploy a new package to the <b>production</b> environment. Please double-check before
            confirming. All running flows will be stopped.
          </p>
        </Box>

        <Box sx={{ boxShadow: '4px 4px 10px rgba(0, 0, 0, 0.2)', p: 2 }}>
          <FlexLayout flexDirection="column">
            {/* Package name row */}
            <FlexLayout>
              <Box sx={{ width: '30%' }}>
                <b>Package</b>
              </Box>
              <p>{packageData?.getPackage?.name}</p>
            </FlexLayout>
          </FlexLayout>

          <Box my={2}>
            <hr />
          </Box>

          {/* Version Row */}
          <FlexLayout>
            <Box sx={{ width: '30%' }}>
              <b>Version</b>
            </Box>
            <p>{packageVersion?.getPackageVersion?.version}</p>
          </FlexLayout>

          {/* Created Row */}
          <FlexLayout>
            <Box sx={{ width: '30%' }}>
              <b>Version created</b>
            </Box>
            <p>{new Date(packageVersion?.getPackageVersion?.createdAt).toLocaleString('nl', LOCALE_DATE_OPTIONS)}</p>
          </FlexLayout>
        </Box>
      </Box>
    </Modal>
  ) : null;
};
